import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "viewPage contacts" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "contact-container" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "contact-item-0" }, "Contact Us"),
    /*#__PURE__*/_createElementVNode("div", { class: "contact-content" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "contact-pair" }, [
        /*#__PURE__*/_createElementVNode("h2", { class: "contact-item-1" }, "Call Us"),
        /*#__PURE__*/_createElementVNode("ul", null, [
          /*#__PURE__*/_createElementVNode("li", null, "+995 597 117 117")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "contact-pair" }, [
        /*#__PURE__*/_createElementVNode("h2", { class: "contact-item-2" }, "Mail Us"),
        /*#__PURE__*/_createElementVNode("ul", null, [
          /*#__PURE__*/_createElementVNode("li", null, "hello@goldsgym.ge"),
          /*#__PURE__*/_createElementVNode("li", null, "info@goldsgym.ge")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "contact-pair location-pair" }, [
        /*#__PURE__*/_createElementVNode("h2", { class: "contact-item-4" }, "Visit Us"),
        /*#__PURE__*/_createElementVNode("h3", { class: "contact-item-5" }, "117 Akaki Beliashvili Street, Tbilisi"),
        /*#__PURE__*/_createElementVNode("div", { class: "map-container" }, [
          /*#__PURE__*/_createElementVNode("iframe", {
            class: "embedded-map",
            src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d239.60541231025687!2d44.781627376142204!3d41.77553539954899!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40446d16e1780faf%3A0xba225737920d1b0!2zR09MROKAmVMgR1lN!5e0!3m2!1ska!2sge!4v1694033935306!5m2!1ska!2sge",
            style: {"border":"0"},
            allowfullscreen: "true",
            loading: "lazy",
            referrerpolicy: "no-referrer-when-downgrade"
          })
        ])
      ])
    ])
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  id: "copy-alert-id",
  class: "contact-item-3"
}, "Text Copied!", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2
  ], 64))
}